import React from 'react';
import Relay from 'react-relay';

import { BLACK, WHITE, BLUE, GREEN } from 'depop/styles/colors';
import { FAMILY_STANDARD, FAMILY_STANDARD_BOLD } from 'depop/styles/typography';

import { trackFollowUser, trackUnfollowUser } from 'depop/utils/tracking';
import { FormattedMessage } from 'react-intl';
import { css } from 'glamor';

import { loginConnector } from 'depop/connectors';

import FollowUserMutation from '../mutations/FollowUserMutation';

class FollowButton extends React.Component {
  props: {
    user: Object,
    currentUser: Object,
    size: String,
    openLogin: () => void,
  };

  static contextTypes = {
    relay: Relay.PropTypes.Environment,
  };

  handleClick = event => {
    const { user, openLogin, currentUser } = this.props;
    const { viewerMetadata, socialCounters } = user;

    if (!currentUser) {
      openLogin();
      return;
    }

    const isFollowing = viewerMetadata && viewerMetadata.viewerIsFollowing;

    if (isFollowing) {
      trackUnfollowUser({
        username: user.username,
        id: user.publicId,
      });
    } else {
      trackFollowUser({
        username: user.username,
        id: user.publicId,
      });
    }

    event.preventDefault();

    const mutationProps = {
      user,
      viewerMetadata,
      socialCounters,
      action: isFollowing ? 'unfollow' : 'follow',
    };

    this.context.relay.commitUpdate(new FollowUserMutation(mutationProps));
  };

  render() {
    const { user, currentUser, size } = this.props;
    const { viewerMetadata } = user;

    const isFollowing = viewerMetadata && viewerMetadata.viewerIsFollowing;
    const currentBGColor = isFollowing ? GREEN : BLUE;
    const otherBGColor = isFollowing ? BLUE : GREEN;

    const buttonWidth = size && size === 'large' ? 202 : 104;

    if (currentUser && user.id === currentUser.id) {
      return null;
    }

    return (
      <a
        {...css({
          display: 'block',
          position: 'relative',
          color: WHITE, //isFollowing ? WHITE : BLACK,
          backgroundColor: currentBGColor,
          border: `1px solid ${currentBGColor}`,
          textDecoration: 'none',
          fontSize: 15,
          width: buttonWidth,
          height: 28,
          cursor: 'pointer',
          '@media (min-width: 701px)': {
            ':hover': {
              color: WHITE,
              backgroundColor: otherBGColor, //isFollowing ? '#333333' : BLACK,
              border: `1px solid ${otherBGColor}`,
            }
          }
        })}
        href="javascript:;"
        onClick={this.handleClick}>
        <span
          {...css({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'block',
            lineHeight: '26px',
            textAlign: 'center',
            visibility: isFollowing ? 'visible' : 'hidden',
            fontFamily: FAMILY_STANDARD_BOLD,
          })}>
          <FormattedMessage
            id="app.unfollowLabelUpper"
            description="Uppercase Unfollow Label"
            defaultMessage="Following"
          />
        </span>
        <span
          {...css({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'block',
            lineHeight: '26px',
            textAlign: 'center',
            visibility: isFollowing ? 'hidden' : 'visible',
            fontFamily: FAMILY_STANDARD,
          })}>
          <FormattedMessage
            id="app.followLabelUpper"
            description="Lowercase Follow Label"
            defaultMessage="Follow"
          />
        </span>
      </a>
    );
  }
}

export default Relay.createContainer(loginConnector(FollowButton), {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        id
        publicId
        username
        ${Relay.Mutation.getFragment.call(FollowUserMutation, 'user')}
        viewerMetadata {
          ${Relay.Mutation.getFragment.call(
            FollowUserMutation,
            'viewerMetadata',
          )}
          viewerIsFollowing
        }
        socialCounters {
          ${Relay.Mutation.getFragment.call(
            FollowUserMutation,
            'socialCounters',
          )}
        }
      }
    `,
    currentUser: () => Relay.QL`
      fragment on User {
        id
        publicId
        username
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/FollowButton.js